import { useState } from 'react'
import { useDynamicMainToolbar } from 'shared/hooks/useMainToolbar'
import { MainToolbarContextContent } from '../MainToolbarContextContent/MainToolbarContextContent'
import { LocationSelectDialog } from './LocationSelectDialog'
import { FilterSelectDialog } from './FilterSelectDialog'
import { SpyLaunchSettingsDialog } from './SpyLaunchSettingsDialog'

interface DefaultContextControlProps{
    location: any
    locationSearchString: string
    filter: any
    spyLaunchSettings: any
    onLocationSearchStringChange?: (event: any) => void
    onLocationChange?: (event: any) => void
    onFiltersChange?: (event: any) => void
    onSpyLaunchSettingsChange?: (event: any) => void  
    onSearch?: (event: any) => void
}

export const DefaultContextControl = (props: DefaultContextControlProps) => {
    const {
        location,
        locationSearchString,
        filter,
        spyLaunchSettings,
        onLocationSearchStringChange,
        onLocationChange,
        onFiltersChange,
        onSpyLaunchSettingsChange,
        onSearch
    } = props
    const [locationSelectDialogOpen, setLocationSelectDialogOpen] = useState<boolean>(false)
    const [FilterDialogOpen, setFilterDialogOpen] = useState<boolean>(false)
    const [launchSettingsDialogOpen, setLaunchSettingsDialogOpen] = useState<boolean>(false) 

    const handleLocationButtonClick = () => {
        setFilterDialogOpen(false)
        setLaunchSettingsDialogOpen(false)
        setLocationSelectDialogOpen((prev: boolean) => !prev)
    }
    const handleSearchButtonClick = () => {
        onSearch?.({
            location,
            locationSearchString,
            filter,
            spyLaunchSettings
        })
    }

    const handleFilterButtonClick = () => {
        setLaunchSettingsDialogOpen(false)
        setLocationSelectDialogOpen(false)
        setFilterDialogOpen((prev: boolean) => !prev)
    }

    const handleSpyLaunchSettingsButtonClick = () => {
        setLocationSelectDialogOpen(false)
        setFilterDialogOpen(false)
        setLaunchSettingsDialogOpen((prev: boolean) => !prev)
    }

    const handleSearchCloseButtonClick = () => {
        setLocationSelectDialogOpen(false)
    }

    const handleFilterCloseButtonClick =() => {
        setFilterDialogOpen(false)
    }

    const handleLaunchSettingsCloseButtonClick = () => {
       setLaunchSettingsDialogOpen(false)
    }

    const handleLocationSelectDialogSearch = (event: any) => {
        onSearch?.(event)
        setLocationSelectDialogOpen(false)
    }

    const handleLocationSelectDialogClose = () => {
       setLocationSelectDialogOpen(false)
    }

    const handleFilterSelectDialogClose = () => {
        setFilterDialogOpen(false)
    }

    const handleSpyLaunchSettingsDialogSpyLaunchSettingsChange = (event: any) => {
        onSpyLaunchSettingsChange?.(event)    
    }

    const handleLocationSelectDialogSpyLaunchSettingsChange = (event: any) => {
        onSpyLaunchSettingsChange?.(event)    
    }

    const handleLocationSelectDialogLocationSearchStringChange = () => {
        throw new Error('handleLocationSelectDialogLocationSearchStringChange')
    }

    const handleLocationSelectDialogChange = (event: any) => {
        onLocationChange?.(event)
        if (event !== undefined){
            setLocationSelectDialogOpen(false)
        }
    }

    const handleSpyLaunchSettingsDialogClose = () => {
       setLaunchSettingsDialogOpen(false)
    }

    const handleFilterSelectDialogFilterChange = (event: any) => {
        onFiltersChange?.(event)
    }

    const mainToolbarContent = (
        <MainToolbarContextContent 
            location={location}
            locationSearchString={locationSearchString}
            filter={filter}
            spyLaunchSettings={spyLaunchSettings}
            locationActive={locationSelectDialogOpen}
            spyLaunchSettingsActive={launchSettingsDialogOpen}
            filterActive={FilterDialogOpen}
            onLocationButtonClick={handleLocationButtonClick}
            onSearchButtonClick={handleSearchButtonClick}
            onFilterButtonClick={handleFilterButtonClick}          
            onSpyLaunchSettingsButtonClick={handleSpyLaunchSettingsButtonClick}    
            onSearchCloseButtonClick={handleSearchCloseButtonClick}    
            onFilterCloseButtonClick={handleFilterCloseButtonClick}  
            onLaunchSettingsCloseButtonClick={handleLaunchSettingsCloseButtonClick} />
    )

    useDynamicMainToolbar(mainToolbarContent, [
        location,
        spyLaunchSettings,
        locationSelectDialogOpen,
        launchSettingsDialogOpen,
        FilterDialogOpen
    ])

    return (
        <>
            <LocationSelectDialog
                location={location}
                //locationSearchString={locationSearchString}
                filter={filter}
                spyLaunchSettings={spyLaunchSettings}
                open={locationSelectDialogOpen}
                onSearch={handleLocationSelectDialogSearch}
                onClose={handleLocationSelectDialogClose}
                onLocationChange={handleLocationSelectDialogChange}
                onLocationSearchStringChange={handleLocationSelectDialogLocationSearchStringChange}
                onSpyLaunchSettingsChange={handleLocationSelectDialogSpyLaunchSettingsChange}
                onFiltersChange={handleFilterSelectDialogFilterChange}
            />
            
            <SpyLaunchSettingsDialog
                spyLaunchSettings={spyLaunchSettings} 
                open={launchSettingsDialogOpen}
                onSpyLaunchSettingsChange={handleSpyLaunchSettingsDialogSpyLaunchSettingsChange}
                onClose={handleSpyLaunchSettingsDialogClose}
            
            />
            <FilterSelectDialog
                open={FilterDialogOpen}
                filters={filter}
                onClose={handleFilterSelectDialogClose}
                onFiltersChange={handleFilterSelectDialogFilterChange}
            />
        </>
    )
}